import useSWR from "swr";

import { fetcher } from "../model/fetcher";
import { ApiIncidentType } from "@store/types";

export const useAllIncidentsData = () => {
    const { data, error } = useSWR<{ incidents: ApiIncidentType[] }>("/incidents.json", fetcher, {
        refreshInterval: 3000,
    });

    return { data: data?.incidents, error };
};
